
import axios, { AxiosRequestConfig } from 'axios';
import { CommonAxiosServiceWp } from './common-axios-service-wp';
import { AssociatesResponse, BiMessageIdRequest, BiMessageModel, BiMessageResponse, CommonResponse, CompanyBiMessageResponse, CompanyDeptRoleCategoryCodeRequest, CompanyIdBiMsgIdRequest, CompanyIdRequest, CompanyModel, CompanyModuleIdRequest, CompanyReq, CompanyResponse, DepartmentDropResponse, ExcelImportModel, ExcelImportResponse, GlobalResponseObject, ModuleIdRequest, WhatsappLogResponseModel, companyandModuleandDateReq, whatsappsLogDto } from '@schemax-whatsapp/shared-models';

export class BiMessageService extends CommonAxiosServiceWp {
  whatsappUrl = '/api/message-broadcast'

  private getURLwithMainEndPoint(childUrl: string) {
    return '/bi-message/' + childUrl;
  }

  async createBiMessage(request: BiMessageModel, config?: AxiosRequestConfig): Promise<BiMessageResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('createBiMessage'), request, config);
  }

  async updateBiMessage(request: BiMessageModel, config?: AxiosRequestConfig): Promise<BiMessageResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('updateBiMessage'), request, config);
  }

  async deleteBiMessage(request: BiMessageIdRequest, config?: AxiosRequestConfig): Promise<BiMessageResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('deleteBiMessage'), request, config);
  }

  async getAllBiMessagesForModule(request: ModuleIdRequest, config?: AxiosRequestConfig): Promise<BiMessageResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllBiMessagesForModule'), request, config);
  }

  async getAllCompanyBiMessagesForModule(companyModuleIdReq?: CompanyModuleIdRequest, config?: AxiosRequestConfig): Promise<CompanyBiMessageResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllCompanyBiMessagesForModule'), companyModuleIdReq, config);
  }

  async mapBiMessageToCompany(companyIdBiMsgIdReq: CompanyIdBiMsgIdRequest, config?: AxiosRequestConfig): Promise<BiMessageResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('mapBiMessageToCompany'), companyIdBiMsgIdReq, config);
  }

  async biMessageStatusApproval(req: BiMessageModel, config?: AxiosRequestConfig): Promise<BiMessageResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('biMessageStatusApproval'), req, config);
  }

  async getScxAssociates(req: CompanyDeptRoleCategoryCodeRequest): Promise<AssociatesResponse> {
    return await axios.post('/whatsapp-broad-cast/getScxAssociates', req)
      .then(res => {
        return res.data
      })
  }

  async callApis(req: CompanyDeptRoleCategoryCodeRequest): Promise<GlobalResponseObject> {
    return await axios.post(this.whatsappUrl + '/callApis', req)
      .then(res => {
        return res.data
      })
  }
  async getScxDepartment(req: CompanyDeptRoleCategoryCodeRequest): Promise<DepartmentDropResponse> {
    return await axios.post(this.whatsappUrl + '/getScxDepartment', req)
      .then(res => {
        return res.data
      })
  }
  // async getAllModulesandCompany(req: CompanyReq): Promise<CompanyBiMessageResponse> {
  //   return await axios.post(this.URL + '/getAllModulesandCompany', req)
  //     .then(res => {
  //       return res.data
  //     })
  // }
  async getAllModulesandCompany(request: CompanyReq, config?: AxiosRequestConfig): Promise<CompanyBiMessageResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllModulesandCompany'), request, config);
  }
  async getwhatsappLogsreport(request: companyandModuleandDateReq, config?: AxiosRequestConfig): Promise<CommonResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('getwhatsappLogsreport'), request, config);
  }
  async getAllModuleForwhtsappLogs(request: CompanyReq, config?: AxiosRequestConfig): Promise<CommonResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllModuleForwhtsappLogs'), request, config);
  }

  async createWhatappLog(dto: whatsappsLogDto, config?: AxiosRequestConfig): Promise<CommonResponse> {
    return await this.axiosPostCall(this.getURLwithMainEndPoint('createWhatappLog'), dto, config);
  }
}



